function n(o) {
  return !!(o !== null && typeof o == "object" && "href" in o && o.href && "protocol" in o && o.protocol && // @ts-expect-error: indexing is fine.
  o.auth === void 0);
}
export {
  n as isUrl
};
//# sourceMappingURL=minurl.shared.js.map
